<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <!-- Basic options -->
              <div class="row">
                <div class="col-md-6">
                  <h3 class="my-4">{{ 'lang.attributedatatypes.datatypeDetails' | translate }}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="ID">{{ 'lang.globals.id' | translate }}<span class="red">*</span></label>
                        <input type="text" id="ID" class="form-control" formControlName="ID"
                               sbAutofocus>
                        <span
                          class="form-text text-muted">{{ 'lang.globals.idDescription' | translate }}</span>
                        <div *ngIf="ID.touched && ID.errors?.required"
                             class="alert alert-danger">
                          {{ 'lang.globals.idWarning' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Title">{{ 'lang.globals.name' | translate }}<span class="red">*</span></label>
                        <input type="text" id="Title" class="form-control"
                               formControlName="Name">
                        <span
                          class="form-text text-muted">{{ 'lang.globals.nameDescription' | translate }}</span>
                        <div *ngIf="Name.touched && Name.errors?.required"
                             class="alert alert-danger">
                          {{ 'lang.globals.nameWarning' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe">
                        <label class="form-label"
                               for="Description">{{ 'lang.globals.description' | translate }}</label>
                        <input type="text" id="Description" class="form-control"
                               formControlName="Description">
                        <span
                          class="form-text text-muted">{{ 'lang.globals.descriptionDescription' | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="form-label" for="Type">{{ 'lang.globals.type' | translate }}<span class="red">*</span></label>
                        <select id="Type" class="form-select" formControlName="Type">
                          <option
                            *ngPermissions="permissionService.Permission.device_attribute_datatype_create"
                            [ngValue]="'DeviceAttribute'">{{ 'lang.globals.deviceAttribute' | translate }}
                          </option>
                          <option
                            *ngPermissions="permissionService.Permission.location_attribute_datatype_create"
                            [ngValue]="'LocationAttribute'">{{ 'lang.globals.locationAttribute' | translate }}
                          </option>
                          <option
                            *ngPermissions="permissionService.Permission.company_attribute_datatype_create"
                            [ngValue]="'CompanyAttribute'">{{ 'lang.globals.companyAttribute' | translate }}
                          </option>
                          <option
                            *ngPermissions="permissionService.Permission.product_attribute_datatype_create"
                            [ngValue]="'ProductAttribute'">{{ 'lang.globals.productAttribute' | translate }}
                          </option>
                          <option
                            *ngPermissions="permissionService.Permission.medium_group_attribute_datatype_create"
                            [ngValue]="'MediumAttribute'">{{ 'lang.globals.mediumAttribute' | translate }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed">
                  <!-- Values -->
                  <h3 class="my-4">{{ 'lang.attributedatatypes.datatypeValues' | translate }}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="UniqueValues" formControlName="UniqueValues">
                          <label class="form-check-label"
                                 for="UniqueValues">{{ 'lang.attributedatatypes.uniqueValues' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.uniqueValuesDescription' | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group validateMe d-block">
                        <label class="form-label"
                               for="DefaultValue">{{ 'lang.attributedatatypes.defaultValue' | translate }}</label>
                        <input type="text" id="DefaultValue" class="form-control"
                               formControlName="DefaultValue">
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.defaultValueDescription' | translate }}</span>
                        <div *ngIf="DefaultValue.touched && DefaultValue.errors?.required"
                             class="alert alert-danger">
                          {{ 'lang.attributedatatypes.defaultValueWarning' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input" id="Multiline"
                                 formControlName="Multiline">
                          <label class="form-check-label"
                                 for="Multiline">{{ 'lang.attributedatatypes.multiline' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.multilineDescription' | translate }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label class="form-label"
                               for="RegExp">{{ 'lang.attributedatatypes.regExp' | translate }}</label>
                        <input type="text" id="RegExp" class="form-control"
                               formControlName="RegExp">
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.regExpDescription' | translate }}</span>
                        <div *ngIf="RegExp.touched && (RegExp.errors?.required || RegExp.errors?.regex)"
                             class="alert alert-danger">
                          {{ 'lang.attributedatatypes.regExpWarning' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed">
                  <!-- Allowed Values -->
                  <div class="tw-flex tw-justify-between tw-items-center">
                    <h3 class="my-4">{{ 'lang.attributedatatypes.allowedValues' | translate }}</h3>
                    <div class="form-check form-switch">
                      <input type="checkbox" role="switch" class="form-check-input" (change)="setAllowedValueInputEnabledDisabled()"
                             id="AllowAllowedValues" formControlName="AllowAllowedValues">
                    </div>
                  </div>
                  <!--
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <label class="form-label"
                               for="AllowedValues">{{ 'lang.globals.values' | translate }}</label>
                        <textarea rows="3" id="AllowedValues" formControlName="AllowedValues" class="form-control"></textarea>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.allowedValuesDescription' | translate }}</span>
                      </div>
                    </div>
                  </div>
                  -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="tw-w-full tw-mb-2">
                        <div class="tw-flex tw-flex-row tw-gap-2 tw-flex-wrap tw-min-h-8">
                          @for (keyword of attribute?.allowedValues ?? []; track keyword) {
                            <div
                              [ngClass]="{'hover:tw-bg-sbBlue-500 dark:hover:tw-bg-sbBlue-700 hover:tw-text-white': AllowAllowedValues.value && !attribute.global}"
                              class="tw-pointer-events-auto tw-justify-center tw-shrink-0 tw-h-7 tw-py-1.5 tw-px-3 tw-flex tw-items-center tw-flex-row tw-gap-2 tw-rounded-full tw-font-medium tw-transition-all tw-ease-in-out tw-duration-200 tw-bg-sbBlue-50 dark:tw-bg-sbBlue-400 tw-text-sbBlue-700 dark:tw-text-white">
                              <span class="tw-line-clamp-1">{{ keyword }}</span>
                              <sb-icon *ngIf="AllowAllowedValues.value && !attribute.global" icon="cancel"
                                       class="tw-text-xs tw-cursor-pointer "
                                       (click)="removeKeyword(keyword)"
                              ></sb-icon>
                            </div>
                          } @empty {
                            <i class="text-muted">
                              {{ 'lang.globals.noItems' |translate }}
                            </i>
                          }
                        </div>
                      </div>
                      <input
                        class="form-control tw-mb-2"
                        [disabled]="!AllowAllowedValues.value || attribute.global"
                        (submit)="null"
                        (keydown.enter)="onKeyboardEnter($event)"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <label class="form-check-label" for="PercentageBase">{{ 'lang.globals.amount' | translate }}:</label>
                        <div id="PercentageBase" class="tw-w-full">
                          <div *ngFor="let base of countTypes" class="form-check">
                            <input type="radio" class="form-check-input" name="PercentageBase" id="{{base}}" value="{{base}}"
                                   [checked]="base === selectedType" (change)="setCountType(base)"
                                   [disabled]="!AllowAllowedValues.value || attribute.global" />
                            <label for="{{base}}"
                                   class="form-check-label tw-ml-3">{{ 'lang.attribute.' + base?.toLowerCase() | translate }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="AllowedValuesMinCount" class="form-check-label">min</label>
                        <input type="number" class="form-control tw-w-fit" formControlName="AllowedValuesMinCount"
                               id="AllowedValuesMinCount">

                        <label for="AllowedValuesMaxCount" class="tw-ml-3">max</label>
                        <input type="number" class="form-control tw-w-fit" formControlName="AllowedValuesMaxCount"
                               id="AllowedValuesMaxCount">
                      </div>
                    </div>
                  </div>
                  <hr class="border-dashed d-md-none">
                </div>
                <!-- Settings -->
                <div class="col-md-6">
                  <h3 class="my-4">{{ 'lang.attributedatatypes.settings' | translate }}</h3>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="AdPlacerAbleToSet" formControlName="AdPlacerAbleToSet">
                          <label class="form-check-label"
                                 for="AdPlacerAbleToSet">{{ 'lang.attributedatatypes.adPlacerAbleToSet' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.adPlacerAbleToSetDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12" *ngIf="attributeType === 'DeviceAttribute'">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="DeviceAbleToSet" formControlName="DeviceAbleToSet">
                          <label class="form-check-label"
                                 for="DeviceAbleToSet">{{ 'lang.attributedatatypes.deviceAbleToSet' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.deviceAbleToSetDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="AskForConfirmation" formControlName="AskForConfirmation">
                          <label class="form-check-label"
                                 for="AskForConfirmation">{{ 'lang.attributedatatypes.askForConfirmation' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.askForConfirmationDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="ExternalSynchronized"
                                 formControlName="ExternalSynchronized">
                          <label class="form-check-label"
                                 for="ExternalSynchronized">{{ 'lang.attributedatatypes.externalSynchronized' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.externalSynchronizedDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="UsableForFilters" formControlName="UsableForFilters">
                          <label class="form-check-label"
                                 for="UsableForFilters">{{ 'lang.attributedatatypes.usableForFilters' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.usableForFiltersDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="Searchable" formControlName="Searchable">
                          <label class="form-check-label"
                                 for="Searchable">{{ 'lang.attributedatatypes.searchable' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.searchableDescription' | translate }}</span>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group d-block">
                        <div class="form-check form-switch">
                          <input type="checkbox" role="switch" class="form-check-input"
                                 id="DisclosedToPublic" formControlName="DisclosedToPublic">
                          <label class="form-check-label"
                                 for="DisclosedToPublic">{{ 'lang.attributedatatypes.disclosedToPublic' | translate }}</label>
                        </div>
                        <span
                          class="form-text text-muted">{{ 'lang.attributedatatypes.disclosedToPublicDescription' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button (click)="cancel()"
                        class="btn btn-default btn-lg btn-wide">
                  {{ 'lang.globals.cancel' | translate }}
                </button>
                <button *ngIf="!attribute?.global" (click)="submit()" [disabled]="!form.valid || loading"
                        class="btn btn-success btn-wide btn-lg">
                  {{ 'lang.globals.submit' | translate }}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
